import React, { useState, useContext, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment-timezone";
import MainLoader from "../../../utils/MainLoader/MainLoader";
import AuthContext from "../../../contexts/AuthContext";
import AvTimerIcon from '@mui/icons-material/AvTimer';
import { MdRemoveRedEye } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import { MdAdminPanelSettings, MdPermContactCalendar } from "react-icons/md";
import { FiUpload } from "react-icons/fi";
import mapicon from "../../../assets/mapicon.svg"
import { GoPlus } from "react-icons/go";
import { Table, Space, Input, Checkbox, Button, Divider, Tag, Modal, List, Card, Typography, Flex, Select, DatePicker, Upload, message } from "antd";
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';
import axios from "axios";
import { CheckCircleTwoTone } from '@ant-design/icons';
import CreateAppTask from './CreateAppTask';
import UploadDataModal from '../../../DataUpload/Upload';
import AssignWebTask from '../ProductList/AssignWebTask';


const ViewTask = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [tasks, setTasks] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [taskDetails, setTaskDetails] = useState(null);
    const [selectedTaskType, setSelectedTaskType] = useState(undefined);
    const [sortCriterion, setSortCriterion] = useState(undefined);
    const navigate = useNavigate();
    const location = useLocation();
    const { role } = useContext(AuthContext);
    const { Paragraph } = Typography;
    const { TextArea } = Input;
    const { Option } = Select;
    const [newDueDate, setNewDueDate] = useState(null);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [delayFormVisible, setDelayFormVisible] = useState(false);
    const [delayReason, setDelayReason] = useState('');
    const [delayReasonType, setDelayReasonType] = useState('');
    const [delayComments, setDelayComments] = useState('');
    const [delayFileList, setDelayFileList] = useState([]);
    const [refreshData, setRefreshData] = useState(false);
    const [uploadDataVisible, setUploadDataVisible] = useState(false);

    // New states for uploaded video data and task assignment
    const [uploadedVideos, setUploadedVideos] = useState([]);
    const [loadingVideos, setLoadingVideos] = useState(false);
    const [selectedVideos, setSelectedVideos] = useState([]);
    const [assignTaskModalVisible, setAssignTaskModalVisible] = useState(false);
    const [filterUploadedText, setFilterUploadedText] = useState('');

    // States for survey history library
    const [groupedByRoadId, setGroupedByRoadId] = useState({});
    const [selectedRoadId, setSelectedRoadId] = useState(null);
    const [expandedRoadIds, setExpandedRoadIds] = useState([]);

    const getLocalOrganization = () => {
        const orgFromStorage = window.localStorage.getItem('organization') || '';
        const userFromStorage = JSON.parse(window.localStorage.getItem('user') || '{}');
        return (orgFromStorage || userFromStorage?.organization || '').toString().trim().toLowerCase();
    };

    const belongsToCurrentOrganization = (row = {}) => {
        const currentOrg = getLocalOrganization();
        if (!currentOrg) {
            return true;
        }

        const rowOrg = (
            row.organization ||
            row.organization_name ||
            row.org ||
            row.org_name ||
            row.organization_id ||
            ''
        ).toString().trim().toLowerCase();

        return !rowOrg || rowOrg === currentOrg;
    };

    const handleRefreshData = () => {
        setRefreshData(prevState => !prevState);
    };
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        navigate(location.pathname);
    };

    const handleDelayFormSubmit = async () => {
        if (!delayReasonType) {
            message.error('Please select a delay reason type');
            return;
        }
        if (!delayComments.trim()) {
            message.error('Please provide delay comments');
            return;
        }

        try {
            const formData = new FormData();
            formData.append('taskId', taskDetails.taskid);
            formData.append('delayReasonType', delayReasonType);
            formData.append('delayComments', delayComments);
            
            // Add uploaded files to form data
            delayFileList.forEach((file, index) => {
                if (file.originFileObj) {
                    formData.append(`delayFiles`, file.originFileObj);
                }
            });

            await axios.post(
                `${process.env.REACT_APP_BASE_URL}task/submit_delay_reason`,
                formData,
                { 
                    headers: { 
                        'Content-Type': 'multipart/form-data' 
                    } 
                }
            );

            message.success('Delay reason submitted successfully');
            setDelayFormVisible(false);
            resetDelayForm();
            handleRefreshData();
        } catch (error) {
            console.error('Error submitting delay reason:', error);
            message.error('Failed to submit delay reason');
        }
    };

    const resetDelayForm = () => {
        setDelayReasonType('');
        setDelayComments('');
        setDelayFileList([]);
    };

    const handleDelayFileChange = ({ fileList }) => {
        setDelayFileList(fileList);
    };
    useEffect(() => {
        const fetchTasks = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BASE_URL}task/list_tasks`);
                const scopedTasks = (response.data.tasks || []).filter((task) => belongsToCurrentOrganization(task));
                setTasks(scopedTasks);
                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setIsLoading(false);
            }
        };

        fetchTasks();
    }, [refreshData]);

    // Fetch uploaded video data from video_upload collection using get_video_list endpoint
    useEffect(() => {
        const fetchUploadedVideos = async () => {
            try {
                setLoadingVideos(true);
                const token = localStorage.getItem('token')?.replace(/^"|"$/g, '');

                // Fetch from the get_video_list endpoint which returns all video_upload collection data
                const response = await axios.get(
                    `${process.env.REACT_APP_BASE_URL}dataUpload/get_video_list`,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                console.log('===== BACKEND RESPONSE FROM get_video_list =====');
                console.log('Full response:', response);
                console.log('Response data:', response.data);
                console.log('Response status:', response.status);
                console.log('Response headers:', response.headers);

                // The response should contain the video_upload collection data
                const videos = response.data.videos || response.data.result || response.data || [];

                console.log('Extracted videos array:', videos);
                console.log('Number of videos:', videos.length);
                if (videos.length > 0) {
                    console.log('First video sample:', videos[0]);
                    console.log('Video fields:', Object.keys(videos[0]));
                }

                // Transform the uploaded video data
                const videoData = videos.map((video, index) => {
                    console.log(`Processing video ${index + 1}:`, video);
                    let createdDate = video.created;
                    let formattedCreated = createdDate;

                    if (createdDate) {
                        const dateObj = new Date(createdDate);
                        if (!isNaN(dateObj)) {
                            const options = { weekday: 'short', year: 'numeric', month: 'short', day: '2-digit' };
                            formattedCreated = dateObj.toLocaleDateString('en-US', options).replace(',', '');
                            const parts = formattedCreated.split(' ');
                            if (parts.length === 4) {
                                formattedCreated = `${parts[0]}, ${parts[1]} ${parts[2]} ${parts[3]}`;
                            }
                        }
                    }

                    const transformedVideo = {
                        uid: video.video_uid || video.uid, // Video UID (backend returns video_uid)
                        road_id: video.road_id || 'N/A',
                        organization: video.organization || video.organization_name || '',
                        organization_id: video.organization_id || '',
                        sub_road_id: video.sub_road_id || 0, // Include sub_road_id for sorting
                        project_title: video.project_title || 'N/A',
                        upload_date: video.created?.$date || video.created || new Date().toISOString(), // Store raw ISO date for grouping
                        upload_date_display: formattedCreated, // Store formatted date for display
                        start_latitude: video.start_latitude || 'N/A',
                        start_longitude: video.start_longitude || 'N/A',
                        end_latitude: video.end_latitude || 'N/A',
                        end_longitude: video.end_longitude || 'N/A',
                        road_type: video.road_type || 'N/A',
                        starting_address: video.starting_address || 'N/A',
                        ending_address: video.ending_address || 'N/A',
                        file_size: video.file_size || 'N/A',
                        video_length: video.video_length || 'N/A',
                        status: video.status || 'N/A'
                    };

                    console.log(`Transformed video ${index + 1}:`, transformedVideo);
                    return transformedVideo;
                });

                const scopedVideoData = videoData.filter((video) => belongsToCurrentOrganization(video));

                console.log('===== FINAL TRANSFORMED VIDEO DATA =====');
                console.log('Total videos transformed:', videoData.length);
                console.log('All transformed videos:', videoData);
                console.log('=======================================');

                // Group videos by Road ID
                const grouped = {};
                scopedVideoData.forEach(video => {
                    const roadId = video.road_id;
                    if (!grouped[roadId]) {
                        grouped[roadId] = {
                            road_id: roadId,
                            road_name: video.project_title,
                            videos: []
                        };
                    }
                    grouped[roadId].videos.push(video);
                });

                // Sort videos within each road by sub_road_id (ascending), then by date (newest first)
                Object.keys(grouped).forEach(roadId => {
                    grouped[roadId].videos.sort((a, b) => {
                        // First sort by sub_road_id (ascending)
                        if (a.sub_road_id !== b.sub_road_id) {
                            return a.sub_road_id - b.sub_road_id;
                        }
                        // If sub_road_ids are equal, sort by date (newest first)
                        const dateA = new Date(a.upload_date);
                        const dateB = new Date(b.upload_date);
                        return dateB - dateA;
                    });
                });

                console.log('Grouped by Road ID:', grouped);

                setUploadedVideos(scopedVideoData);
                setGroupedByRoadId(grouped);
                setLoadingVideos(false);
            } catch (error) {
                console.error('===== ERROR FETCHING VIDEO DATA =====');
                console.error('Error object:', error);
                console.error('Error message:', error.message);
                console.error('Error response:', error.response);
                console.error('Error response data:', error.response?.data);
                console.error('Error response status:', error.response?.status);
                console.error('======================================');
                setLoadingVideos(false);
                message.error('Failed to load uploaded video data. Please try again.');
            }
        };

        fetchUploadedVideos();
    }, [refreshData]);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const taskID = queryParams.get('taskID');

        if (taskID) {
            const task = tasks.find((task) => task.taskid === taskID);
            if (task) {
                setTaskDetails(task);
                setIsModalOpen(true);
            }
        }
    }, [location.search, tasks]);

    const handleViewDetails = (task) => {
        setTaskDetails(task);
        setIsModalOpen(true);
        const taskURL = `${location.pathname}?taskID=${task.taskid}`;
        navigate(taskURL);
    };

    const { Search } = Input;
    const [checkboxState, setCheckboxState] = useState({
        allTasks: true,
        pending: true,
        inProgress: true,
        completed: true,
        overdue: true,
        closed: true,
    });
    const [indeterminate, setIndeterminate] = useState(false);
    const handleCheckboxChange = (checkbox) => {
        if (checkbox === 'allTasks') {
            const newState = !checkboxState.allTasks;
            setCheckboxState({
                allTasks: newState,
                pending: newState,
                inProgress: newState,
                completed: newState,
                overdue: newState,
                closed: newState,
            });
            setIndeterminate(false);
        } else {
            setCheckboxState((prevState) => ({
                ...prevState,
                [checkbox]: !prevState[checkbox],
            }));
            const newState = {
                ...checkboxState,
                [checkbox]: !checkboxState[checkbox],
            };
            const { allTasks, ...rest } = newState;
            const allChecked = Object.values(rest).every((value) => value);
            const anyChecked = Object.values(rest).some((value) => value);

            setIndeterminate(!allChecked && anyChecked);
            setCheckboxState((prevState) => ({
                ...prevState,
                allTasks: allChecked,
            }));
        }
    };
    const [filteredTasks, setFilteredTasks] = useState([]);
    useEffect(() => {
        const filterTasks = () => {
            let filtered = [...tasks];

            // Filter by search text
            if (searchText) {
                filtered = filtered.filter(task =>
                    task.taskTitle.toLowerCase().includes(searchText.toLowerCase())
                );
            }

            // Filter by status
            if (!checkboxState.allTasks) {
                const selectedStatuses = Object.entries(checkboxState)
                    .filter(([key, value]) => value && key !== 'allTasks')
                    .map(([key]) => {
                        switch (key) {
                            case 'pending': return 'Pending';
                            case 'inProgress': return 'In Progress';
                            case 'completed': return 'Completed';
                            case 'overdue': return 'Overdue';
                            case 'closed': return 'Closed';
                            default: return '';
                        }
                    });
                filtered = filtered.filter(task => selectedStatuses.includes(task.status));
            }

            // Filter by task type
            if (selectedTaskType) {
                filtered = filtered.filter(task => task.taskType.toLowerCase() === selectedTaskType);
            }

            // Sort the filtered tasks
            filtered.sort((a, b) => {
                switch (sortCriterion) {
                    case 'dueDate':
                        return new Date(b.dueDate) - new Date(a.dueDate);
                    case 'createdDate':
                        return new Date(b.created_at) - new Date(a.created_at);
                    case 'assignedTo':
                        return a.assignedTo.localeCompare(b.assignedTo);
                    default:
                        return 0;
                }
            });

            setFilteredTasks(filtered);
        };

        filterTasks();
    }, [tasks, checkboxState, selectedTaskType, sortCriterion, searchText]);
    const handleTaskTypeChange = (value) => {
        setSelectedTaskType(value);
    };
    const resetFilters = () => {
        setSelectedTaskType(undefined);
        setSortCriterion(undefined);
    };
    const handleSearch = (value) => {
        setSearchText(value);
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };

    const CustomTableHeader = ({ checkboxState, handleCheckboxChange }) => (
        <>
            <div style={{ width: '100%' }}>
                <Search
                    placeholder="Search for a task"
                    allowClear
                    enterButton={<Button type="primary" ghost style={{ color: 'white' }}>Search</Button>}
                    size="large"
                    onSearch={handleSearch}
                    style={{ width: '100%' }}
                />
            </div>
            <Divider style={{ margin: '5px 0px' }} />
            <Space>
                <Select
                    value={sortCriterion}
                    style={{ width: 200, borderColor: '#1890ff' }}
                    onChange={(value) => setSortCriterion(value)}
                    placeholder="Sort by"
                >
                    <Option value="dueDate">Due Date</Option>
                    <Option value="createdDate">Created Date</Option>
                    <Option value="assignedTo">Assigned To</Option>
                </Select>

                <Select
                    value={selectedTaskType}
                    placeholder="Filter by task type"
                    style={{ width: 250, borderColor: '#1890ff' }}
                    onChange={handleTaskTypeChange}
                >
                    <Option value="maintenance">Maintenance</Option>
                    <Option value="survey">Survey</Option>
                </Select>
                <Button type="primary" ghost style={{ color: 'white' }} onClick={resetFilters}>Clear filter</Button>
                <Checkbox
                    indeterminate={indeterminate}
                    checked={checkboxState.allTasks}
                    onChange={() => handleCheckboxChange('allTasks')}
                >
                    All Task
                </Checkbox>
                <Checkbox
                    checked={checkboxState.pending}
                    onChange={() => handleCheckboxChange('pending')}
                >
                    Pending
                </Checkbox>
                <Checkbox
                    checked={checkboxState.inProgress}
                    onChange={() => handleCheckboxChange('inProgress')}
                >
                    In Progress
                </Checkbox>
                <Checkbox
                    checked={checkboxState.completed}
                    onChange={() => handleCheckboxChange('completed')}
                >
                    Completed
                </Checkbox>
                <Checkbox
                    checked={checkboxState.overdue}
                    onChange={() => handleCheckboxChange('overdue')}
                >
                    Overdue
                </Checkbox>
                <Checkbox
                    checked={checkboxState.closed}
                    onChange={() => handleCheckboxChange('closed')}
                >
                    Closed
                </Checkbox>
            </Space>
        </>
    );

    const columns = [
        {
            title: 'Task Title',
            dataIndex: 'taskTitle',
            key: 'taskTitle',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Task Type',
            dataIndex: 'taskType',
            key: 'taskType',
        },
        {
            title: 'Assigned To',
            dataIndex: 'assignedTo',
            key: 'assignedTo',
        },
        {
            title: 'Created On',
            dataIndex: 'created_at',
            key: 'createdOn',
        },
        {
            title: 'Due Date',
            dataIndex: 'dueDate',
            key: 'dueDate',
            render: (dueDate) => {
                const date = new Date(dueDate);
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                });
            },
        },
        {
            title: 'Status',
            key: 'status',
            dataIndex: 'status',
            render: (status) => {
                switch (status) {
                    case 'Closed':
                        return <Tag color="#ECECEC" style={{ color: '#425466' }}>Closed</Tag>;
                    case 'Pending':
                        return <Tag color="#FFFBD2" style={{ color: '#B35A04' }}>Pending</Tag>;
                    case 'In Progress':
                        return <Tag color="#EBF3FF" style={{ color: '#1967D2' }}>In Progress</Tag>;
                    case 'Completed':
                        return <Tag color="#DEFFE7" style={{ color: '#34A853' }}>Completed</Tag>;
                    case 'Overdue':
                        return <Tag color="#FFE3E3" style={{ color: '#DA2727' }}>Overdue</Tag>;
                    default:
                        return null;
                }
            },

        },
        {
            title: 'Action',
            key: 'action',
            render: (record) => (
                <Space size="middle">
                    {record.status === 'Closed' ? (
                        <MdRemoveRedEye onClick={() => handleViewDetails(record)} style={{ cursor: 'pointer' }} />
                    ) : (
                        <AiFillEdit onClick={() => handleViewDetails(record)} style={{ cursor: 'pointer' }} />
                    )}
                </Space>
            ),
        },
    ];

    const statusBodyTemplate = (taskDetails) => {
        const getStatusTag = (status) => {
            switch (status) {
                case 'Closed':
                    return <Tag color="#ECECEC" style={{ color: '#425466' }}>Closed</Tag>;
                case 'Pending':
                    return <Tag color="#FFFBD2" style={{ color: '#B35A04' }}>Pending</Tag>;
                case 'In Progress':
                    return <Tag color="#EBF3FF" style={{ color: '#1967D2' }}>In Progress</Tag>;
                case 'Completed':
                    return <Tag color="#DEFFE7" style={{ color: '#34A853' }}>Completed</Tag>;
                case 'Overdue':
                    return <Tag color="#FFE3E3" style={{ color: '#DA2727' }}>Overdue</Tag>;
                default:
                    return null;
            }
        };

        return taskDetails.status ? getStatusTag(taskDetails.status) : null;
    };

    const renderContent = () => {
        if (taskDetails) {
            return (
                <Card
                    title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <span>
                                    Assigned Task Details
                                </span>
                                <span style={{ fontSize: 14, fontWeight: 400 }}>
                                    Type: {taskDetails.taskType} Task
                                </span>
                            </div>

                            <div className="flex items-center" style={{ position: 'relative', width: 250, height: 45 }}>
                                <MdAdminPanelSettings style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', zIndex: 10 }} />
                                <Input
                                    disabled={true}
                                    value={`Assigned by ${taskDetails.assignedBy}`}
                                    style={{ paddingLeft: 35, width: '100%', height: '100%', borderRadius: 20, fontWeight: 600 }}
                                />
                            </div>
                        </div>
                    }
                    bordered={false}
                    style={{ width: '100%' }}
                >
                    <Paragraph style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#EFFBFF', padding: '10px', margin: '0 -24px', textAlign: 'center' }}>
                        <img src={mapicon} alt="map" />{taskDetails.roadNames}
                    </Paragraph>
                    <Flex gap="small">
                        <Flex gap="small" vertical>
                            <div
                                id="scrollableDiv"
                                style={{
                                    height: 100,
                                    width: 320,
                                    backgroundColor: '#fff',
                                    overflow: 'hidden',
                                    margin: '16px 0px',
                                    padding: '16px',
                                    border: '1px solid #fff',
                                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>Assigned user for this task</div>
                                <div
                                    style={{
                                        overflowY: 'auto',
                                        maxHeight: '58px',
                                    }}
                                >
                                    <List size="small">
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                padding: '10px',
                                                backgroundColor: 'transparent',
                                            }}
                                        >
                                            <MdPermContactCalendar />{taskDetails.assignedTo}
                                        </div>
                                    </List>
                                </div>
                            </div>
                            <div
                                id="scrollableDiv"
                                style={{
                                    height: 190,
                                    width: 320,
                                    backgroundColor: '#fff',
                                    overflow: 'hidden',
                                    padding: '16px',
                                    border: '1px solid #fff',
                                    boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                <List size="small"
                                    header={<div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}>Task status</span>
                                        <span>{statusBodyTemplate(taskDetails)}</span>
                                    </div>
                                    }
                                >
                                    <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}> Created on </span>
                                        <span>{taskDetails.created_at}</span>
                                    </div>
                                    {taskDetails.accepted_at && (
                                        <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: 16, fontWeight: 600 }}> Accepted on </span>
                                            <span>{taskDetails.accepted_at}</span>
                                        </div>
                                    )}
                                    {taskDetails.completed_at && (
                                        <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: 16, fontWeight: 600 }}> Completed on </span>
                                            <span>{taskDetails.completed_at}</span>
                                        </div>
                                    )}
                                    {taskDetails.closed_at && (
                                        <div style={{ display: 'flex', marginTop: '5px', justifyContent: 'space-between' }}>
                                            <span style={{ fontSize: 16, fontWeight: 600 }}> Closed on </span>
                                            <span>{taskDetails.closed_at}</span>
                                        </div>
                                    )}
                                </List>
                            </div>
                        </Flex>
                        <div
                            id="taskdiv"
                            style={{
                                height: 313,
                                flexGrow: 1,
                                overflow: 'hidden',
                                margin: '16px 0px',
                                padding: '0px 16px',
                                border: '1px solid #fff',
                                boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
                                overflowY: 'auto',
                            }}
                        >
                            <Flex gap="small" vertical>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <span style={{ fontSize: 16, fontWeight: 600 }}>Task Title</span>
                                    <span >{taskDetails.taskTitle}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginTop: 2 }}>
                                    <span style={{ fontSize: 16, fontWeight: 600 }}>Task Description</span>
                                    <span>{taskDetails.taskDescription}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 16 }}>
                                    <span style={{ marginRight: '16px', fontSize: 16, fontWeight: 600 }}>Due Date</span>
                                    <span style={{ fontSize: 16, fontWeight: 400 }}>{formatDate(taskDetails.dueDate)}</span>
                                    {taskDetails.status === 'Overdue' && (
                                        <DatePicker
                                            id="date"
                                            value={newDueDate}
                                            onChange={(date, dateString) => setNewDueDate(date)}
                                            style={{ marginLeft: 16 }}
                                            disabledDate={disabledDate}
                                        />
                                    )}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 2 }}>
                                    <span style={{ marginRight: '32px', fontSize: 16, fontWeight: 600 }}>Task ID</span>
                                    <span style={{ fontSize: 16, fontWeight: 400 }}>{taskDetails.taskid}</span>
                                </div>
                                {taskDetails.feedback && (
                                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 2, marginBottom: 4 }}>
                                        <span style={{ fontSize: 16, fontWeight: 600 }}>Feedback from the assigned user</span>
                                        <TextArea
                                            disabled={true}
                                            placeholder="Feedback from the assigned user"
                                            autoSize={{ minRows: 3, maxRows: 4 }}
                                            style={{ width: '100%', height: '100%', fontWeight: 600, backgroundColor: '#EDEDED' }}
                                            value={taskDetails.feedback}
                                        />
                                    </div>
                                )}
                            </Flex>
                        </div>
                    </Flex>
                </Card >
            );
        }
        return null;
    }
    const footerContent = () => {
        const handleReset = async () => {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}task/reset_due_date`,
                    { taskId: taskDetails.taskid, newDueDate: newDueDate },
                    { headers: { 'Content-Type': 'application/json' } }
                )
                handleRefreshData();
                setIsModalOpen(false);
            } catch (error) {
                console.error(error);
            }
        };
        const handleClosed = async () => {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}task/close_task`,
                    { taskId: taskDetails.taskid },
                    { headers: { 'Content-Type': 'application/json' } }
                )
                handleRefreshData();
                setIsModalOpen(false);
            } catch (error) {
                console.error(error);
            }
        };
        if (taskDetails) {
            if (taskDetails.status === 'Closed') {
                return [<Button key="close" danger ghost onClick={handleCancel}>Close this window</Button>];
            } else if (taskDetails.status === 'Overdue') {
                return [
                    <div key="button-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button key="exit" danger ghost onClick={handleCancel}>Exit</Button>
                        <Button key="reset" type="primary" icon={<AvTimerIcon />} style={{ background: '#1967D2' }} onClick={handleReset}>Reset Due Date</Button>
                    </div>
                ];
            } else {
                return [
                    <div key="button-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button key="exit" danger ghost onClick={handleCancel}>Exit</Button>
                        <Button key="assign" type="primary" icon={<CheckCircleTwoTone />} style={{ background: '#1967D2' }} onClick={handleClosed}>Closed Task</Button>
                    </div>
                ];
            }
        }
    };

    // Function to group videos by month and assign survey numbers based on unique days
    const groupVideosByMonth = (videos) => {
        const grouped = {};
        const dayToSurveyNumber = {}; // Track unique days for survey numbering

        // First, identify unique days and assign survey numbers
        const uniqueDays = [...new Set(videos.map(v => {
            const date = new Date(v.upload_date);
            return date.toISOString().split('T')[0]; // Get YYYY-MM-DD
        }))].sort();

        uniqueDays.forEach((day, index) => {
            dayToSurveyNumber[day] = index + 1;
        });

        // Then group by month and add survey numbers
        videos.forEach(video => {
            const date = new Date(video.upload_date);
            if (!isNaN(date)) {
                const monthYear = date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
                const dayKey = date.toISOString().split('T')[0];

                if (!grouped[monthYear]) {
                    grouped[monthYear] = {};
                }

                if (!grouped[monthYear][dayKey]) {
                    grouped[monthYear][dayKey] = {
                        surveyNumber: dayToSurveyNumber[dayKey],
                        videos: []
                    };
                }

                grouped[monthYear][dayKey].videos.push(video);
            }
        });

        return grouped;
    };

    // Toggle Road ID expansion
    const toggleRoadExpansion = (roadId) => {
        setExpandedRoadIds(prev =>
            prev.includes(roadId)
                ? prev.filter(id => id !== roadId)
                : [...prev, roadId]
        );
    };

    // Handle video selection
    const handleVideoSelection = (selectedRowKeys, selectedRows) => {
        setSelectedVideos(selectedRows);
    };

    // Handle Assign Task button click
    const handleAssignTaskClick = () => {
        if (selectedVideos.length === 0) {
            message.warning('Please select at least one video to assign a task');
            return;
        }
        setAssignTaskModalVisible(true);
    };

    return (
        <>
            {/* Action Buttons */}
                <div className="flex justify-end gap-3 px-8 py-4">
                    {role === 'Admin' && (
                        <button
                            type="button"
                            className="text-white bg-[#173a66] hover:bg-[#102a4c] font-medium rounded-lg text-sm px-5 py-2.5 flex gap-2 items-center shadow-lg transition-all"
                            onClick={() => setDialogVisible(true)}
                        >
                            <GoPlus size={18} /> Add User Survey Task
                        </button>
                    )}
                    <button
                        type="button"
                        className="text-gray-700 bg-white hover:bg-gray-50 font-medium rounded-lg text-sm px-5 py-2.5 flex gap-2 items-center shadow-sm transition-all border border-gray-300"
                        onClick={() => setUploadDataVisible(true)}
                    >
                        <FiUpload size={18} /> Upload Data
                    </button>
                    <button
                        type="button"
                        className="text-white bg-[#173a66] hover:bg-[#102a4c] font-medium rounded-lg text-sm px-5 py-2.5 flex gap-2 items-center shadow-lg transition-all"
                        onClick={() => setDelayFormVisible(true)}
                    >
                        Submit Delay Reason
                    </button>
                </div>

            {/* Survey History Library Section */}
            <div className="table-container p-6 mx-5 mb-5 bg-white rounded-lg shadow-md">
                <div className="mb-6">
                    <h2 className="text-2xl font-bold text-[#0A2540] mb-2">Survey History Library</h2>
                    <p className="text-[#5F6368] mb-4">View survey history organized by Road ID and upload date.</p>

                    <div className="flex justify-between items-center mb-4">
                        <Input
                            placeholder=" Search by Road ID or Road Name..."
                            value={filterUploadedText}
                            onChange={(e) => setFilterUploadedText(e.target.value)}
                            style={{ width: 400 }}
                            size="large"
                            allowClear
                        />
                    </div>
                </div>

                {loadingVideos ? (
                    <div className="flex justify-center items-center py-20">
                        <MainLoader />
                    </div>
                ) : (
                    <div className="space-y-4">
                        {Object.keys(groupedByRoadId).filter(roadId =>
                            roadId.toLowerCase().includes(filterUploadedText.toLowerCase()) ||
                            groupedByRoadId[roadId].road_name.toLowerCase().includes(filterUploadedText.toLowerCase())
                        ).map((roadId) => {
                            const roadData = groupedByRoadId[roadId];
                            const isExpanded = expandedRoadIds.includes(roadId);
                            const videosByMonth = groupVideosByMonth(roadData.videos);

                            // Calculate sub_road_id range for this road
                            const subRoadIds = roadData.videos.map(v => v.sub_road_id).filter(id => id > 0).sort((a, b) => a - b);
                            const minSubRoadId = subRoadIds.length > 0 ? Math.min(...subRoadIds) : 0;
                            const maxSubRoadId = subRoadIds.length > 0 ? Math.max(...subRoadIds) : 0;
                            const subRoadIdDisplay = minSubRoadId > 0 ? (minSubRoadId === maxSubRoadId ? `Segment ${minSubRoadId}` : `Segments ${minSubRoadId}-${maxSubRoadId}`) : '';

                            return (
                                <div key={roadId} className="border border-gray-200 rounded-lg overflow-hidden">
                                    {/* Road Header */}
                                    <div
                                        className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 cursor-pointer hover:from-blue-100 hover:to-indigo-100 transition-all"
                                        onClick={() => toggleRoadExpansion(roadId)}
                                    >
                                        <div className="flex justify-between items-center">
                                            <div className="flex items-center gap-4">
                                                <div className="bg-blue-600 text-white rounded-lg px-3 py-1 font-mono font-bold text-sm">
                                                    {roadId}
                                                </div>
                                                <div>
                                                    <h3 className="font-semibold text-[#0A2540] text-lg">{roadData.road_name}</h3>
                                                    <div className="flex items-center gap-2">
                                                        <p className="text-sm text-[#5F6368]">{roadData.videos.length} survey(s) available</p>
                                                        {subRoadIdDisplay && (
                                                            <>
                                                                <span className="text-sm text-[#5F6368]">•</span>
                                                                <p className="text-sm text-orange-600 font-medium">{subRoadIdDisplay}</p>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-2xl text-blue-600">
                                                {isExpanded ? '▼' : '▶'}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Expanded Content - Videos by Month and Day */}
                                    {isExpanded && (
                                        <div className="p-4 bg-gray-50">
                                            {Object.keys(videosByMonth).sort((a, b) => new Date(b) - new Date(a)).map((monthYear) => {
                                                const daysInMonth = videosByMonth[monthYear];
                                                const totalSurveys = Object.keys(daysInMonth).length;

                                                return (
                                                    <div key={monthYear} className="mb-4 last:mb-0">
                                                        <h4 className="font-semibold text-[#0A2540] mb-3 flex items-center gap-2">
                                                            <span className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm">
                                                                📅 {monthYear}
                                                            </span>
                                                            <span className="text-sm text-gray-500">({totalSurveys} survey{totalSurveys > 1 ? 's' : ''})</span>
                                                        </h4>

                                                        <div className="space-y-4">
                                                            {Object.keys(daysInMonth).sort((a, b) => new Date(b) - new Date(a)).map((dayKey) => {
                                                                const dayData = daysInMonth[dayKey];
                                                                const surveyNumber = dayData.surveyNumber;
                                                                const videosForDay = dayData.videos;

                                                                return (
                                                                    <div key={dayKey} className="bg-white border-2 border-blue-200 rounded-lg p-4">
                                                                        <div className="mb-3 flex items-center gap-2">
                                                                            <span className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm font-bold">
                                                                                Survey #{surveyNumber}
                                                                            </span>
                                                                            <span className="text-sm text-gray-600">
                                                                                {new Date(dayKey).toLocaleDateString('en-US', {
                                                                                    weekday: 'short',
                                                                                    year: 'numeric',
                                                                                    month: 'short',
                                                                                    day: 'numeric'
                                                                                })}
                                                                            </span>
                                                                            {videosForDay.length > 1 && (
                                                                                <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                                                                    {videosForDay.length} videos uploaded
                                                                                </span>
                                                                            )}
                                                                        </div>

                                                                        <div className="grid grid-cols-1 gap-2">
                                                                            {videosForDay.map((video, videoIndex) => (
                                                                                <div
                                                                                    key={video.uid}
                                                                                    className="bg-gray-50 border border-gray-200 rounded-lg p-3"
                                                                                >
                                                                                    <div className="flex items-start gap-3">
                                                                                        <div className="flex-1">
                                                                                            <div className="flex items-center gap-2 mb-2">
                                                                                                {videosForDay.length > 1 && (
                                                                                                    <span className="text-xs font-medium text-gray-600 bg-white px-2 py-1 rounded border">
                                                                                                        Video {videoIndex + 1}
                                                                                                    </span>
                                                                                                )}
                                                                                                {video.sub_road_id > 0 ? (
                                                                                                    <Tag color="orange">
                                                                                                        Segment {video.sub_road_id}
                                                                                                    </Tag>
                                                                                                ) : (
                                                                                                    <Tag color="red">
                                                                                                        No Segment ID
                                                                                                    </Tag>
                                                                                                )}
                                                                                                <Tag color={video.road_type === 'LHS' ? 'blue' : video.road_type === 'RHS' ? 'green' : 'purple'}>
                                                                                                    {video.road_type}
                                                                                                </Tag>
                                                                                            </div>

                                                                                            <div className="grid grid-cols-2 gap-2 text-xs">
                                                                                                <div>
                                                                                                    <span className="text-gray-500">Start: </span>
                                                                                                    <span className="font-mono">{video.start_latitude}, {video.start_longitude}</span>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <span className="text-gray-500">End: </span>
                                                                                                    <span className="font-mono">{video.end_latitude}, {video.end_longitude}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            );
                        })}

                        {Object.keys(groupedByRoadId).length === 0 && (
                            <div className="text-center py-20">
                                <p className="text-gray-500 text-lg">No survey data available. Upload data to get started.</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Task Management Table Section */}
            <div className="table-container p-6 mx-5 mb-5 bg-white rounded-lg shadow-md">
                <div className="mb-4">
                    <h2 className="text-2xl font-bold text-[#0A2540] mb-2">Task Management</h2>
                    <p className="text-[#5F6368] mb-4">Manage user maintenance and survey request tasks</p>
                </div>
                {isLoading ? <MainLoader /> :
                    <Table
                        columns={columns}
                        dataSource={filteredTasks}
                        bordered
                        title={() => <CustomTableHeader setSearchText={setSearchText} checkboxState={checkboxState} handleCheckboxChange={handleCheckboxChange} />}
                        scroll={{
                            y: 240,
                        }}
                    />
                }
            </div>
            <Modal
                centered
                closable={false}
                open={isModalOpen}
                onCancel={handleCancel}
                width="70vw"
                footer={footerContent()}
            >
                {renderContent()}
            </Modal>

            <CreateAppTask
                open={dialogVisible}
                onHide={() => setDialogVisible(false)}
                onTaskAssigned={handleRefreshData}
            />

            {/* Delay Reason Form Modal */}
            <Modal
                title="Submit Delay Reason"
                open={delayFormVisible}
                onCancel={() => {
                    setDelayFormVisible(false);
                    resetDelayForm();
                }}
                footer={[
                    <Button 
                        key="cancel" 
                        onClick={() => {
                            setDelayFormVisible(false);
                            resetDelayForm();
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button 
                        key="submit" 
                        type="primary" 
                        onClick={handleDelayFormSubmit}
                        style={{ background: '#1967D2' }}
                    >
                        Submit Delay Reason
                    </Button>
                ]}
                width={600}
                centered
            >
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Reason Type <span className="text-red-500">*</span>
                        </label>
                        <Select
                            value={delayReasonType}
                            onChange={setDelayReasonType}
                            placeholder="Select delay reason type"
                            style={{ width: '100%' }}
                            size="large"
                        >
                            <Option value="weather">Weather Conditions</Option>
                            <Option value="equipment">Equipment Issues</Option>
                            <Option value="traffic">Traffic/Road Access Issues</Option>
                            <Option value="permit">Permit/Authorization Delays</Option>
                            <Option value="safety">Safety Concerns</Option>
                            <Option value="personnel">Personnel Unavailability</Option>
                            <Option value="technical">Technical Issues</Option>
                            <Option value="administrative">Administrative Delays</Option>
                            <Option value="other">Other</Option>
                        </Select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Comments <span className="text-red-500">*</span>
                        </label>
                        <TextArea
                            value={delayComments}
                            onChange={(e) => setDelayComments(e.target.value)}
                            placeholder="Please provide detailed explanation for the delay..."
                            rows={4}
                            maxLength={500}
                            showCount
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Supporting Documents (Optional)
                        </label>
                        <Upload.Dragger
                            fileList={delayFileList}
                            onChange={handleDelayFileChange}
                            beforeUpload={() => false} // Prevent auto upload
                            multiple
                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        >
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                                Click or drag files to this area to upload
                            </p>
                            <p className="ant-upload-hint">
                                Support for PDF, Word documents, and images. Multiple files allowed.
                            </p>
                        </Upload.Dragger>
                    </div>
                </div>
            </Modal>

            {/* Upload Data Modal */}
            <UploadDataModal
                visible={uploadDataVisible}
                onClose={() => {
                    setUploadDataVisible(false);
                    handleRefreshData(); // Refresh data after upload
                }}
            />

            {/* Assign Task Modal for Selected Videos */}
            {selectedVideos.length > 0 && (
                <AssignWebTask
                    open={assignTaskModalVisible}
                    onHide={() => {
                        setAssignTaskModalVisible(false);
                        setSelectedVideos([]);
                    }}
                    uid={selectedVideos.map(v => v.uid).join(',')} // Pass all selected video UIDs
                    roadName={
                        selectedVideos.length === 1
                            ? selectedVideos[0].project_title
                            : `${selectedVideos.length} videos selected (${selectedVideos[0].road_id || 'Multiple Road IDs'})`
                    }
                    onTaskAssigned={() => {
                        handleRefreshData();
                        setSelectedVideos([]);
                    }}
                    taskDetails={null}
                    selectedVideos={selectedVideos} // Pass all selected videos for same Road ID assignment
                />
            )}
        </>
    )
}

export default ViewTask